import * as Sentry from '@sentry/vue'
import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'
import tracking from './services/tracking'
import router from '../router'
import store from '@/store'
import { getCsrfTokenFromCookie } from '@/utils/auth'
import './assets/styles.css'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import './assets/toast-badges.css' // badge-style override (must load after the lib CSS)
import { library, config } from '@fortawesome/fontawesome-svg-core'
config.autoAddCss = false
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCaretRight,
  faChartSimple,
  faCirclePlus,
  faKey,
  faTrashCan,
  faCheck,
  faCircleMinus,
  faHospital,
  faHouseMedical,
  faClipboardList,
  faList,
  faCircleXmark,
  faMap,
  faUserNurse,
  faQuestionCircle,
  faAngleDown,
  faShareFromSquare,
  faDiamond,
  faUserDoctor,
  faPlus,
  faAngleRight,
  faSquareCheck,
  faChevronRight,
  faPeopleGroup,
  faMagnifyingGlass,
  faDownload,
  faFile,
  faArrowUp,
  faArrowDown,
  faMapPin,
  faUser,
  faHouseChimneyMedical,
  faCircleInfo,
  faEllipsis,
  faQuestion,
  faUserPen,
  faBug,
  faLock,
  faHouseMedicalCircleCheck,
  faFileArrowDown,
  faCircleExclamation,
  faHourglassStart,
  faTruckMedical,
  faBook,
  faPersonCane,
  faCalendarDays,
  faPills,
  faBullseye,
  faThumbsDown,
  faThumbsUp,
  faRepeat,
  faUserInjured,
  faCodeBranch,
  faFlask,
  faSync,
  faAmbulance,
  faDoorOpen,
  faPersonWalking,
  faHourglassHalf,
  faDoorClosed,
  faHourglassEnd,
  faBed,
  faWheelchairMove,
  faBell,
  faEye,
  faUserPlus,
  faComment,
  faUserSlash,
  faFolder,
  faFolderOpen,
  faPerson,
  faHashtag,
  faCircle,
  faChevronLeft,
  faFileLines,
  faUserCheck,
  faClipboard,
  faFileCircleCheck,
  faIdCard,
  faTasks,
  faCalendar,
  faArrowLeft,
  faSpinner,
  faStethoscope,
  faCalendarCheck,
  faExchangeAlt,
  faMaximize,
  faCalendarDay,
  faArrowRight,
  faFlag,
  faPrescriptionBottle,
  faSmoking,
  faFileMedical,
  faBriefcase,
  faLayerGroup,
  faRobot,
  faHeartPulse,
  faTable,
  faWandMagicSparkles,
  faTimeline,
  faNotesMedical,
  faPencil,
  faTurnDown,
  faFileInvoice,
  faCopy,
  faUsersCog,
  faFolderTree,
  faBolt,
  faMessage,
  faClockRotateLeft,
  faDatabase,
  faChartBar,
  faBan,
  faExclamationTriangle,
  faEllipsisVertical,
  faSitemap,
  faCompressArrowsAlt,
  faSyncAlt,
  faExclamationCircle,
  faTimes,
  faInbox,
  faCheckCircle,
  faUpRightAndDownLeftFromCenter,
  faDownLeftAndUpRightToCenter,
  faArrowRightFromBracket,
  faTag,
  faBars,
  faMagnifyingGlassChart,
  faFlaskVial,
  faGripVertical,
  faSeedling,
  faPaperclip,
  faLifeRing,
  faTicket,
  faSearch,
  faFilePdf,
  faFileImage,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faPhone,
  faPhoneSlash,
  faTrophy,
  faArrowTrendDown,
  faRoadBarrier,
  faBullhorn,
  faBrain,
  faChartLine,
  faCalendarPlus,
  faPen,
  faXmark,
  faVideo,
  faMicrophone,
  faMicrophoneSlash,
  faKeyboard,
  faRightFromBracket,
  faArrowRightToBracket,
  faStar,
  faHeadset,
  faPaperPlane,
  faCheckDouble,
  faCubes,
  faFingerprint,
  faScaleBalanced,
  faHandshake,
  faUsers,
  faComments,
  faDiagramProject,
  faBookOpen,
  faHand,
  faChevronDown,
  faChevronUp,
  faHeart,
  faQuoteLeft,
  faEnvelope,
  faEnvelopeOpen,
  faArrowsRotate,
  faBoxArchive,
  faReply,
  faShareNodes,
  faBedPulse,
  faSackDollar,
  faArrowUpRightFromSquare,
  faGaugeHigh,
  faArrowTrendUp,
  faFileContract,
  faCircleNotch,
  faRotateRight,
  faWaveSquare,
  faArrowRightArrowLeft,
  faRotateLeft,
  faLink,
  faArrowsUpDown,
  faGlobe,
  faLightbulb,
  faLinkSlash,
  faTrash,
  faVolumeHigh,
  faTriangleExclamation,
  faGear,
  faStop,
  faArrowUpFromBracket,
  faArrowRotateLeft,
  faPlay,
} from '@fortawesome/free-solid-svg-icons'
import {
  faCircleQuestion,
  faNoteSticky,
  faBuilding,
  faSquarePlus,
  faSquareMinus,
  faPenToSquare,
  faCircleCheck,
  faClock,
  faStar as faStarRegular,
} from '@fortawesome/free-regular-svg-icons'
import {
  faLightbulbExclamationOn,
  faArrowTurnDownRight,
  faLightEmergency,
  faBallPile,
  faHospitals,
  faChartMixed,
  faArrowsMaximize,
  faArrowsMinimize,
  faClipboardListCheck,
  faBadgeCheck,
} from '@awesome.me/kit-80d119b77f/icons/classic/solid'
import {
  faClipboardCheck,
  faFilter,
  faHouseMedicalFlag,
  faComment as faCommentRegular,
} from '@awesome.me/kit-80d119b77f/icons/classic/regular'
import {
  faCalendar as faCalendarLight,
  faEye as faEyeLight,
  faCalendarClock as faCalendarClockLight,
  faTag as faTagLight,
  faGrid2 as faGrid2Light,
  faBadgeCheck as faBadgeCheckLight,
  faChartBar as faChartBarLight,
  faDiamond as faDiamondLight,
} from '@awesome.me/kit-80d119b77f/icons/classic/light'

// Add icons to the library
library.add(faWaveSquare, faArrowRightArrowLeft, faRotateLeft, faLink,
  faArrowsUpDown, faGlobe, faLightbulb, faLinkSlash, faTrash,
  faCirclePlus, faKey, faTrashCan,faCaretRight,faCircleMinus, faSquarePlus,faSquareCheck,
  faClipboardList, faList, faCircleXmark, faChartSimple, faQuestionCircle, faShareFromSquare,
  faCircleQuestion, faMap, faUserNurse, faNoteSticky, faAngleDown, faCheck, faLightbulbExclamationOn,
  faDiamond,faHospital,faHouseMedical,faBuilding,faUserDoctor,faArrowTurnDownRight, faPlus, faAngleRight,
  faSquareMinus, faChevronRight, faPeopleGroup, faMagnifyingGlass, faMagnifyingGlassChart, faDownload, faFile, faArrowUp,faArrowDown,
  faFilter, faMapPin,faHouseChimneyMedical, faUser, faHouseMedicalFlag, faCircleInfo, faPenToSquare,faEllipsis,faTrophy,faArrowTrendDown,faRoadBarrier,
  faCircleCheck, faQuestion, faUserPen, faBug, faLock, faHouseMedicalCircleCheck,faFileArrowDown,faCircleExclamation,
  faHourglassStart,faTruckMedical,faBook,faPersonCane,faCalendarDays,faPills,faBullseye, faThumbsUp,faThumbsDown, faRepeat,
  faClock, faUserInjured, faCircleInfo,faClipboardCheck, faPhone,faCodeBranch, faFlask, faFlaskVial, faSync, faLightEmergency,
  faHouseMedical,faAmbulance,faDoorOpen,faPersonWalking,faHourglassHalf,faDoorClosed,faHourglassEnd,faBed,
  faWheelchairMove, faClock, faBell,faEye, faUserPlus,faComment,faUserSlash, faFolder, faFolderOpen, faBallPile, faPerson, faHashtag,
  faHospitals, faCircle, faChevronLeft, faFileLines, faUserCheck, faClipboard, faFileCircleCheck, faIdCard, faChartMixed, faTasks, faCalendar, faCalendarLight, faArrowLeft,
  faSpinner,faClipboardList,faStethoscope,faCalendarCheck,faExchangeAlt, faMaximize, faArrowsMaximize, faArrowRight,
  faCalendarDay, faFlag, faArrowsMinimize, faClipboardListCheck,faPrescriptionBottle, faSmoking,faFileMedical,faBriefcase,
  faLayerGroup,faRobot,faClipboardCheck,faHeartPulse, faTable,faWandMagicSparkles,faTimeline,faNotesMedical,
  faClipboardCheck, faPencil, faTurnDown, faFileInvoice, faPhone, faCopy,faUsersCog,faFolderTree, faBolt,faMessage,
  faSitemap, faCompressArrowsAlt, faSyncAlt, faExclamationCircle, faTimes, faInbox, faCheckCircle,
  faClockRotateLeft, faDatabase, faChartBar, faBan, faExclamationTriangle, faEllipsisVertical, faBars,
  faUpRightAndDownLeftFromCenter, faDownLeftAndUpRightToCenter, faArrowRightFromBracket, faEyeLight, faCalendarClockLight, faTagLight, faTag, faGrid2Light, faBadgeCheck, faBadgeCheckLight, faChartBarLight, faDiamondLight,
  faGripVertical, faSeedling, faPaperclip, faLifeRing, faTicket, faSearch, faFilePdf, faFileImage, faFileWord, faFileExcel, faFilePowerpoint,
  faPhone, faPhoneSlash, faBullhorn,
  faBrain, faChartLine, faCalendarPlus, faPen, faXmark,
  faVideo, faMicrophone, faMicrophoneSlash, faKeyboard, faRightFromBracket, faArrowRightToBracket,
  faStar, faStarRegular, faHeadset, faPaperPlane, faChevronDown, faCheckDouble, faCommentRegular,
  faCubes, faFingerprint,
  faScaleBalanced, faHandshake, faUsers, faComments, faDiagramProject,
  faBookOpen, faHand, faChevronUp, faHeart, faQuoteLeft,
  faEnvelope, faEnvelopeOpen, faArrowsRotate, faBoxArchive, faReply,
  faShareNodes, faBedPulse, faSackDollar, faArrowUpRightFromSquare, faFileContract,
  faGaugeHigh, faArrowTrendUp,
  faCircleNotch, faRotateRight,
  faVolumeHigh, faTriangleExclamation, faGear, faStop, faArrowUpFromBracket, faArrowRotateLeft,
  faPlay
)


import 'ag-grid-enterprise'
import {ModuleRegistry} from 'ag-grid-enterprise';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-082018}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Kairon_Health}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Kairon_Health}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Kairon_Health}_need_to_be_licensed___{Kairon_Health}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{3_December_2026}____[v3]_[01]_MTc5NjI1NjAwMDAwMA==3948be0b74d1852030fbc98c2bc90586')



// Register all enterprise features
ModuleRegistry.registerModules([AllEnterpriseModule]);


axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL
axios.defaults.withCredentials = true
// A 2xx response with an unparsable body (e.g. truncated mid-stream by a deploy)
// resolves with the raw string instead of rejecting, letting malformed data flow
// into components expecting an array/object. axios only takes the throw-on-parse-
// failure path when responseType is 'json' AND silentJSONParsing is false — with
// responseType left unset, silentJSONParsing alone does nothing. Both must be set
// together to actually reject.
// Because 'json' is now the global default, ANY call site that expects a non-JSON
// body must opt out per call, or the response will hard-throw on a successful 200:
//   text/plain or text/markdown -> responseType: 'text'
//   file/CSV/audio downloads    -> responseType: 'blob'
// This bit ReleaseNotesPanel, which fetches text/plain markdown and had no override.
axios.defaults.responseType = 'json'
axios.defaults.transitional = { ...axios.defaults.transitional, silentJSONParsing: false }

// Add Axios interceptor to include the current tenant slug in the preferred
// header and the query-parameter fallback.
axios.interceptors.request.use(config => {
  // Send the CSRF token read FRESH from the cookie on every request. Django
  // rotates this token (e.g. on login), so a value snapshotted once into
  // axios.defaults (as fetchUser used to do) goes stale after rotation and
  // causes 403s on writes (POST/PUT/PATCH/DELETE) until a full page reload,
  // while reads keep succeeding. Reading per request removes that window.
  // NB: axios's built-in xsrfCookieName/xsrfHeaderName is NOT a substitute
  // here — on axios >=1.6 it is skipped for cross-origin requests unless
  // withXSRFToken is also enabled, and our API is always a different origin.
  config.headers['X-CSRFToken'] = getCsrfTokenFromCookie()

  if (!config.excludeTenantSlug) {
    const currentTenantSlug = store.getters['tenant/current_tenant_slug']
    if (currentTenantSlug) {
      config.headers['X-Kairon-Tenant-Slug'] = currentTenantSlug
      config.params = {
        ...config.params,
        tenant_slug: currentTenantSlug, // Add tenant slug as query parameter
      }
    }
  }
  return config
})

axios.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      const isAllauth = error.config?.url?.includes('_allauth/')
      const isAlreadyOnLogin = window.location.pathname.includes('/login')
      const wasAuthenticated = store.getters['auth/isAuthenticated']
      if (!isAlreadyOnLogin && !isAllauth && wasAuthenticated) {
        // Preserve the current page so commonLogin() restores it after re-authentication
        localStorage.setItem('last_visited_route', window.location.pathname + window.location.search + window.location.hash);
        window.location.href = '/login?sessionExpired=true';
      }
    }

    return Promise.reject(error);
  }
);

const app = createApp(App)

// Demo Mode capture suppression: Sentry Replay records the live DOM (and,
// before the spoof engine runs, the REAL pre-spoof DOM) and ships it to a third
// party. When a presenter starts a session with Demo Mode already on (the normal
// flow -- the flag is persisted in localStorage), do not start replay/recording
// at all. Runtime toggles are additionally handled in App.vue (Sentry replay is
// stopped on enable). Fail closed: if storage is unreachable, suppress capture.
// Trade-off accepted: a normal (non-demo) user whose localStorage merely throws
// on read will boot with Sentry replay disabled for that session.
// This only loses observability (never breaks the app), and read failures are
// rare, so failing toward not-capturing-PHI is the correct direction.
let demoModeAtBoot;
try {
  demoModeAtBoot = localStorage.getItem('demoMode') === 'true';
} catch {
  demoModeAtBoot = true;
}

// Custom user activity tracking
tracking.setupAxiosTracking()
tracking.start()

// Update tracking context when user/tenant/entity changes
store.subscribe((mutation) => {
  const contextMutations = [
    'auth/SET_USER',
    'auth/CLEAR_USER',
    'tenant/SET_TENANT_SLUG',
    'tenant/SET_TENANT_ACCESS',
    'entity/SET_ENTITY_ID',
    'entity/SET_ENTITY_IDS',
  ]
  if (contextMutations.includes(mutation.type)) {
    tracking.setUserContext({
      userId: store.state.auth.current_user?.id || null,
      tenantSlug: store.state.tenant.current_tenant_slug || null,
      entityId: store.state.entity.current_entity_id || null,
    })
  }
})

Sentry.init({
  app,
  dsn: 'https://e0195cee6a098ac5ad0ba93445dea01f@o4507826902794240.ingest.us.sentry.io/4507827035045888',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    // Omit session replay entirely when Demo Mode is on at boot -- replay would
    // capture the DOM and any pre-spoof flash and send it to Sentry.
    ...(demoModeAtBoot ? [] : [Sentry.replayIntegration()]),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [import.meta.env.VITE_API_BASE_URL],
  tracesSampleRate: 0.1,
  environment: import.meta.env.VITE_ENV,
  sendDefaultPii: true,
  enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',
})


// Register components and directives globally
app.component('FontAwesomeIcon', FontAwesomeIcon)

app.use(Toast, {
  position: 'top-right',
  timeout: 3500,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false,
  transition: 'Vue-Toastification__fade',
})
app.use(router)
app.use(store)
app.config.globalProperties.$axios = axios


app.mount('#app')
